import { useEffect, useState } from "react";
import { PenLine, Code2, Languages, Play, Route, AlertTriangle } from "lucide-react";
import { api, errMsg, errCode } from "@/lib/api";
import { PageHeader, FreeBadge } from "@/components/Common";

const ICONS = { pen: PenLine, code: Code2, languages: Languages };

export default function Assistants() {
  const [list, setList] = useState([]);
  const [active, setActive] = useState(null);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/assistants").then((r) => { setList(r.data); setActive(r.data[0]?.id); }); }, []);

  const run = async () => {
    setBusy(true); setRes(null);
    try {
      const { data } = await api.post(`/assistants/${active}/run`, { input, model: "auto" });
      setRes({ text: data.choices[0].message.content, meta: data.casi });
    } catch (e) {
      setRes({ error: errMsg(e), code: errCode(e) });
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="assistants-page">
      <PageHeader title="KI-Assistenten" subtitle="Fertige Vorlagen, die über das Gateway laufen – immer über die beste kostenlose oder lokale Route." />
      <div className="grid gap-4 md:grid-cols-3">
        {list.map((a) => {
          const I = ICONS[a.icon] || PenLine;
          return (
            <button key={a.id} onClick={() => { setActive(a.id); setRes(null); }} data-testid={`assistant-card-${a.id}`}
              className={`glass p-6 text-left transition-colors ${active === a.id ? "border-blue-500/60 glow" : "hover:border-blue-500/30"}`}>
              <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-violet-600"><I className="h-5 w-5 text-white" /></div>
              <div className="font-semibold text-white">{a.name}</div>
              <p className="mt-1 text-sm text-slate-400">{a.description}</p>
            </button>
          );
        })}
      </div>
      <section className="glass mt-6 p-6">
        <label className="label">Deine Eingabe</label>
        <textarea data-testid="assistant-input" rows={6} className="field mt-2" placeholder="Text, Code oder Aufgabe eingeben…" value={input} onChange={(e) => setInput(e.target.value)} />
        <button onClick={run} disabled={busy || !input.trim() || !active} data-testid="assistant-run-button" className="btn-grad mt-4 inline-flex items-center gap-2 px-5 py-2.5"><Play className="h-4 w-4" />{busy ? "Läuft…" : "Ausführen"}</button>
        {res?.error && (
          <div data-testid="assistant-error" className="mt-5 rounded-lg border border-red-500/40 bg-red-500/10 p-4 text-sm text-red-200">
            <div className="mb-1 flex items-center gap-1.5 font-semibold"><AlertTriangle className="h-4 w-4" />{res.code || "Fehler"}</div>{res.error}
          </div>
        )}
        {res?.text && (
          <div className="mt-5 rounded-lg border border-white/5 bg-black/20 p-4" data-testid="assistant-result">
            <div className="whitespace-pre-wrap text-sm text-slate-100">{res.text}</div>
            <div className="mt-3 flex items-center gap-3 text-[11px] text-slate-400"><Route className="h-3 w-3" />{res.meta.route.provider_name} · {res.meta.route.model}<FreeBadge free={res.meta.route.free} />{res.meta.duration_ms} ms</div>
          </div>
        )}
      </section>
    </div>
  );
}
